<template>

<div class="Data_V_Border">

  <div id="Data_V" v-cloak>

    <!-- Logo + 批次名 + 时间日期 -->
    <div class="Title">
      <img :src="LogoImg" alt="">
      <div> {{ planInfo.planName }} </div>
      <div class="Date">
        <span>{{ YMD }}</span>
        <span>{{ HIS }}</span>
      </div>
    </div>

    <!-- Top -->
    <div class="Top">
      <div class="Top_title">
        <div class="title_A"></div>
        <div class="title_B">数据总览</div>
      </div>
      <div class="Top_main">
        <!-- 剩余报名天数 -->
        <div class="item item_A" v-if=" planInfo.endSignFlag == 0 && planInfo.endPlanFlag == 0">
          <div class="item_dule">
            <div>剩余报名天数</div>
            <div :style="{ 'color': signColor }">{{ planInfo.leftSignDay }}</div>
          </div>
          <div class="dule">
            <div class="dule_item" v-for="(item, key) in 10" :key="key" :style="{ 'background': key < signStep ? '': signColor }"></div>
          </div>
        </div>
        <!-- 剩余审核天数 -->
        <div class="item item_B" v-if=" planInfo.needAudit != 0 && planInfo.endAuditFlag == 0 && planInfo.endPlanFlag == 0 ">
          <div class="item_dule">
            <div>剩余审核天数</div>
            <div :style="{ 'color': auditColor }">{{ planInfo.leftAuditDay }}</div>
          </div>
          <div class="dule">
            <div class="dule_item" v-for="(item, key) in 10" :key="key" :style="{ 'background': key < auditStep ? '': auditColor }"></div>
          </div>
        </div>
        <!-- 剩余缴费天数 -->
        <div class="item item_C" v-if=" planInfo.openPayFlag != 0 && planInfo.endPayFlag == 0 && planInfo.endPlanFlag == 0 ">
          <div class="item_dule">
            <div>剩余缴费天数</div>
            <div :style="{ 'color': payColor }">{{ planInfo.leftPayDay }}</div>
          </div>
          <div class="dule">
            <div class="dule_item" v-for="(item, key) in 10" :key="key" :style="{ 'background': key < payStep ? '': payColor }"></div>
          </div>
        </div>
        <!-- 报名考点/报名教学点  -->
        <div class="item item_D">
          <div class="item_dule">
            <span>
              <CountTo :startVal="placeCount.start" :endVal="placeCount.end" :duration="placeCount.duration"></CountTo>
            </span>
            <span>个</span>
          </div>
          <div class="item_des">
            {{ planInfo.optionalSession == 0 ? '报名教学点数' : '报名考点数' }}
          </div>
        </div>
        <!-- 报名课程 -->
        <div class="item item_D">
          <div class="item_dule">
            <span>
              <CountTo :startVal="courseCount.start" :endVal="courseCount.end" :duration="courseCount.duration"></CountTo>
            </span>
            <span>门</span>
          </div>
          <div class="item_des">
            报名课程
          </div>
        </div>
        <!-- 报名总人数 -->
        <div class="item item_D">
          <div class="item_dule">
            <span :style="{'color': planInfo.signInRange == 1 ? '#FFA63E': ''}">
              <CountTo :startVal="signCount.start" :endVal="signCount.end" :duration="signCount.duration"></CountTo>
            </span>
            <span :style="{'color': planInfo.signInRange == 1 ? '#FFA63E': ''}">人</span>
          </div>
          <div class="item_des" :style="{'color': planInfo.signInRange == 1 ? '#FFA63E': ''}">
            报名总人数
          </div>
        </div>
        <!-- 审核通过总人数 -->
        <div class="item item_D" v-if="planInfo.needAudit != 0">
          <div class="item_dule">
            <span :style="{'color': planInfo.auditInRange == 1 ? '#FFA63E': ''}">
              <CountTo :startVal="auditCount.start" :endVal="auditCount.end" :duration="auditCount.duration"></CountTo>
            </span>
            <span :style="{'color': planInfo.auditInRange == 1 ? '#FFA63E': ''}">人</span>
          </div>
          <div class="item_des" :style="{'color': planInfo.auditInRange == 1 ? '#FFA63E': ''}">
            审核通过总人数
          </div>
        </div>
        <!-- 缴费人次 -->
        <div class="item item_D" v-if=" planInfo.needPay != 0 ">
          <div class="item_dule">
            <span :style="{'color': planInfo.payInRange == 1 ? '#FFA63E': ''}">
              <CountTo :startVal="payCount.start" :endVal="payCount.end" :duration="payCount.duration"></CountTo>
            </span>
            <span :style="{'color': planInfo.payInRange == 1 ? '#FFA63E': ''}">人次</span>
          </div>
          <div class="item_des" :style="{'color': planInfo.payInRange == 1 ? '#FFA63E': ''}">
            缴费人次
          </div>
        </div>
        <!-- 缴费金额 -->
        <div class="item item_D" v-if=" planInfo.needPay != 0 ">
          <div class="item_dule">
            <span :style="{'color': planInfo.payInRange == 1 ? '#FFA63E': ''}">
              <CountTo :startVal="payMoney.start" :endVal="payMoney.end" :duration="payMoney.duration"  :decimals="2"></CountTo>
            </span>
            <span :style="{'color': planInfo.payInRange == 1 ? '#FFA63E': ''}">元</span>
          </div>
          <div class="item_des" :style="{'color': planInfo.payInRange == 1 ? '#FFA63E': ''}">
            缴费金额
          </div>
        </div>
      </div>
    </div>

    <!-- Middle -->
    <div class="Middle">
      <!-- Middle ==> Left -->
      <div class="Left" 
        :style="{ 
          'width': planInfo.needPay == 0 ? '100%' : planInfo.needAudit != 0 ? '3.5rem': '50%',
          'margin-right': planInfo.needPay != 0 ? '0' : planInfo.needAudit != 0 ? '.08rem': '0'
        }"
      >
        <div class="title">
          <div>
            <div class="title_A"></div>
            <div class="title_B">报名人数分布图</div>
          </div>
          <div class="title_C">单位：人</div>
        </div>
        <div id="chart_A"></div>
      </div>
      <!-- Middle ==> Center -->
      <div class="Center" v-show="planInfo.needAudit != 0">
        <div class="title">
          <div>
            <div class="title_A"></div>
            <div class="title_B">审核数据统计</div>
          </div>
          <div class="title_C">单位：人</div>
        </div>
        <div class="strate"> 
          <div>
            <div style="background: #266EFF;"></div>
            <span>待审核</span>
          </div>
          <div>
            <div style="background: #05C985;"></div>
            <span>审核通过</span>
          </div>
          <div>
            <div style="background: #EE423D;"></div>
            <span>审核未通过</span>
          </div>
        </div>
        <div id="chart_B"></div>
      </div>
      <!-- Middle ==> Right -->
      <div class="Right" 
        :style="{ 
          'width': planInfo.needAudit != 0 ? '3.5rem' : '50%', 
          'margin-left': planInfo.needAudit != 0 ? '': '.08rem' 
        }" 
        v-show="planInfo.needPay != 0"
      >
        <div class="title">
          <div>
            <div class="title_A"></div>
            <div class="title_B">缴费金额分布图</div>
          </div>
          <div class="title_C">单位：元</div>
        </div>
        <div id="chart_C" style="width: 100%; height: 100%;"></div>
      </div>
    </div>

    <!-- Bottom -->
    <div class="Bottom">
      <!-- Bottom ==> Left -->
      <div class="Left"
        :style="{ 
          'width': planInfo.needPay == 0 ? '100%' : planInfo.needAudit != 0 ? '3.5rem': '50%', 
          'margin-right': planInfo.needPay != 0 ? '0' : planInfo.needAudit != 0 ? '.08rem': '0'
        }"
      >
        <div class="title">
          <div>
            <div class="title_A"></div>
            <div class="title_B">{{ chang_A ? '实时报名情况': '报名数据统计' }}</div>
          </div>
        </div>
        <div class="charts" style="position: absolute; right: -90%; transition: all 1.5s;" :style="{ 'right': chang_A ? '-100%' : '0' }">
          <div class="chart_D">
            <div class="chart_D_Border">
              <div id="chart_D"></div>
            </div>
            <div class="info_Mob">
              <div class="dit"></div>
              <span>手机端报名</span>
              <span class="number"> 
                <CountTo :startVal="phoneSignNum.start" :endVal="phoneSignNum.end" :duration="phoneSignNum.duration"></CountTo>
              </span>
              <span>人</span>
            </div>
            <div class="info_Web">
              <div class="dit"></div>
              <span>Web端报名</span>
              <span class="number">
                <CountTo :startVal="webSignNum.start" :endVal="webSignNum.end" :duration="webSignNum.duration"></CountTo>
              </span>
              <span>人</span>
            </div>
          </div>
          <div class="chart_E">
            <div class="chart_E_Border">
              <div id="chart_E"></div>
            </div>
            <div style="display: flex; flex-wrap: wrap; margin-left: .2rem; margin-right: -.2rem;">
              <div class="info_A" v-show="data_D.length > 0">
                <div class="dit"></div>
                <span>{{ chart_E_info.one.name }}</span>
                <span class="number">
                  <CountTo :startVal="chart_E_info.one.start" :endVal="chart_E_info.one.end" :duration="chart_E_info.one.duration"></CountTo>
                </span>
                <span>人</span>
              </div>
              <div class="info_B" v-show="data_D.length > 1">
                <div class="dit"></div>
                <span>{{ chart_E_info.two.name }}</span>
                <span class="number"> 
                  <CountTo :startVal="chart_E_info.two.start" :endVal="chart_E_info.two.end" :duration="chart_E_info.two.duration"></CountTo>
                </span>
                <span>人</span>
              </div>
            </div>
          </div>
        </div>
        <!-- List -->
        <div class="list">
          <div class="Scroll" style="transition: all 1.5s;" :style="{ 'left': chang_A ? '0' : '-100%' }">
            <vueSeamlessScroll :data="data_I" class="VueScoll" :class-option="{step: '0.5', limitMoveNum: 7, hoverStop: false}">
              <ul>
                <li
                  v-for="(item, index) in data_I"
                  :key="index"
                >
                  <div class="A"> {{ item.studentName }} </div>
                  <div class="B"> {{ item.operationDate }} </div>
                  <div class="C"> {{ item.operationRemark }} </div>
                </li>
              </ul>
            </vueSeamlessScroll>
          </div>
        </div>

      </div>
      <!-- Bottom ==> Center -->
      <div class="Center" v-show="planInfo.needAudit != 0">
        <div class="title">
          <div>
            <div class="title_A"></div>
            <div class="title_B">实时审核情况</div>
          </div>
        </div>
        <div>
          <div class="Scroll">
            <vueSeamlessScroll :data="data_H" class="VueScoll" :class-option="{step: '0.5', limitMoveNum: 7, hoverStop: false}" >
              <ul>
                <li
                  v-for="(item, index) in data_H"
                  :key="index"
                >
                  <div class="A"> {{ item.studentName }} </div>
                  <div class="B"> {{ item.operationDate }} </div>
                  <div class="C" :style="{ 'color': item.operationRemark == 2 || item.operationRemark == 5 ? '#EE423D' : '#00D86C'}"> 
                    {{ operationRemark[item.operationRemark - 1] }}
                  </div>
                </li>
              </ul>
            </vueSeamlessScroll>
          </div>
        </div>
      </div>
      <!-- Bottom ==> Right -->
      <div class="Right" 
        :style="{ 
          'width': planInfo.needAudit != 0 ? '3.5rem' : '50%', 
          'margin-left': planInfo.needAudit != 0 ? '': '.08rem' 
        }" 
        v-show="planInfo.needPay != 0"
      >
        <div class="title">
          <div>
            <div class="title_A"></div>
            <div class="title_B">缴费数据统计</div>
          </div>
        </div>
        <div class="charts" style="position: absolute; right: -90%; transition: all 1.5s;" :style="{ 'left': chang_A ? '-100%' : '0' }">
          <div class="chart_F">
            <div class="chart_F_Border">
              <div id="chart_F"></div>
            </div>
            <div class="info_Mob" style="margin-right: -.4rem;" v-show="data_E.length > 0">
              <div class="dit"></div>
              <span>{{ chart_F_info.one.name}}</span>
              <span class="number">
                <CountTo :startVal="chart_F_info.one.start" :endVal="chart_F_info.one.end" :duration="chart_F_info.one.duration" :decimals="2"></CountTo>
              </span>
              <span>元</span>
            </div>
            <div class="info_Web"  style="margin-right: -.4rem;" v-show="data_E.length > 1">
              <div class="dit" style="background: #00D86C"></div>
              <span>{{ chart_F_info.two.name}}</span>
              <span class="number">
                <CountTo :startVal="chart_F_info.two.start" :endVal="chart_F_info.two.end" :duration="chart_F_info.two.duration" :decimals="2"></CountTo>
              </span>
              <span>元</span>
            </div>
          </div>
          <div class="chart_G">
            <div class="chart_G_Border">
              <div id="chart_G"></div>
            </div>
            <div class="info_Mob" style="margin-left: .15rem;">
              <div class="dit" style="background: #00D86C"></div>
              <span>已缴</span>
              <span class="number">
                  <CountTo :startVal="chart_G_info.one.start" :endVal="chart_G_info.one.end" :duration="chart_G_info.one.duration"></CountTo>
              </span>
              <span>人</span>
            </div>
            <div class="info_Web" style="margin-left: .15rem;">
              <div class="dit"></div>
              <span>未缴</span>
              <span class="number"> 
                  <CountTo :startVal="chart_G_info.two.start" :endVal="chart_G_info.two.end" :duration="chart_G_info.two.duration"></CountTo>
              </span>
              <span>人</span>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="Scroll" style="transition: all 1.5s;" :style="{ 'right': chang_A ? '0' : '-100%' }">
            <vueSeamlessScroll :data="data_J" class="VueScoll" :class-option="{step: '0.5', limitMoveNum: 7, hoverStop: false}">
              <ul>
                <li
                  v-for="(item, index) in data_J"
                  :key="index"
                >
                  <div class="A"> {{ item.studentName }} </div>
                  <div class="B"> {{ item.operationDate }} </div>
                  <div class="C" :style="{ 'color': item.operationRemark == '缴费成功' ? '#FFF' : '#EE423D' }"> 
                    {{ item.operationRemark }}
                  </div>
                </li>
              </ul>
            </vueSeamlessScroll>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>

</template>

<script>
import CountTo from 'vue-count-to'
import vueSeamlessScroll from "vue-seamless-scroll";
import { getBannerApi, getDataListApi, getAuditInfoApi, getSignAndPayListApi } from '@/http/modules/dataV.js'

export default {
  components: {
    CountTo,
    vueSeamlessScroll
  },
  data() {
    return {
      LogoImg: require("@/assets/img/customDefault.png"),
      YMD: '',
      HIS: '',
      planId: '',
      planInfo: {},
      signStep: '',
      signColor: '',
      auditStep: '',
      auditColor: '',
      payStep: '',
      payColor: '',
      placeCount: {
        start: 0,
        end: 0,
        duration: 3000
      },
      courseCount: {
        start: 0,
        end: 0,
        duration: 3000
      },
      signCount: {
        start: 0,
        end: 0,
        duration: 3000
      },
      auditCount: {
        start: 0,
        end: 0,
        duration: 3000
      },
      payCount: {
        start: 0,
        end: 0,
        duration: 3000
      },
      payMoney: {
        start: 0,
        end: 0,
        duration: 3000
      },
      webSign: '',
      phoneSign: '',
      webSignNum: {
        start: 0,
        end: 0,
        duration: 3000
      },
      phoneSignNum: {
        start: 0,
        end: 0,
        duration: 3000,
      },
      chart_E_info : {
        one: {
          start: 0,
          end: 0,
          duration: 3000,
          name: '',
        },
        two: {
          start: 0,
          end: 0,
          duration: 3000,
          name: '',
        },
        three: {
          start: 0,
          end: 0,
          duration: 3000,
          name: '',
        },
        four: {
          start: 0,
          end: 0,
          duration: 3000,
          name: '',
        }
      },
      chart_F_info: {
        one: {
          start: 0,
          end: 0,
          duration: 3000,
          name: '',
        },
        two: {
          start: 0,
          end: 0,
          duration: 3000,
          name: '',
        },
        three: {
          start: 0,
          end: 0,
          duration: 3000,
          name: '',
        },
        four: {
          start: 0,
          end: 0,
          duration: 3000,
          name: '',
        }
      },
      chart_G_info: {
        one: {
          start: 0,
          end: 0,
          duration: 3000,
        },
        two: {
          start: 0,
          end: 0,
          duration: 3000
        }
      },
      chang_A: false,

      E_Data: '',
      data_A: [],
      data_B: [],
      data_C: [],
      data_D: [],
      data_E: [],
      data_F: [],
      data_G: [],
      data_H: [],
      data_I: [],
      data_J: [],

      operationRemark: ['待初审', '初审不通过', '待终审', '终审通过', '终审不通过'],
      start_ECharts: true,
      colorList: ['#023AFF', '#FFA63E', '#00D86C', '#7300E6', '#EE423D', '#266EFF'],

      Interval_A: '',
      Interval_B: '',
      Interval_C: '',
      Interval_D: '',
      Interval_E: '',
      Interval_F: '',
      Interval_G: '',

      timer_Int: '',
      timer_Change: '',
      timer_data: '',
      currentTime: '',


      isBigScreen: true,


    }
  },

  watch: {
    'planId': 'initECharts',
  },

  methods: {
    /**
     * @param { Logo }
     */
    getCustomSet(){
      let tenant = window.localStorage.getItem('tenant')
      let defaultLogo = require("@/assets/img/customDefault.png")
      this.$api.system.getSystemNameFN({tenant}).then(({data})=>{
        this.LogoImg = data.isUsedLogo == 1 ? data.logoUrl ? data.logoUrl : defaultLogo : defaultLogo
      })
    },

    /**
     * @param { 时间 YMD-HIS }
     */
    currentDate() {
      let that = this
      let nowTime = function() {
        that.YMD = current_YMD()
        that.HIS = current_HIS()
      }
      function twoDigits (val) {
        if (val < 10) return '0' + val
        return val
      }
      function current_YMD() {
        let date = new Date()
        let YMD = date.getFullYear() + '年' + twoDigits(date.getMonth() + 1) + '月' + twoDigits(date.getDate()) + '日'
        return YMD
      }
      function current_HIS() {
        let date = new Date()
        let HIS = twoDigits(date.getHours()) + ':' + twoDigits(date.getMinutes()) + ':' + twoDigits(date.getSeconds())
        return HIS
      }
      this.currentTime = setInterval(nowTime, 1000)
    },

    /**
     * @param { 数字格式 }
     */
    setNumber(p, i) {
      let value = ''
      if (p.value[i] >= 0) {
        value = p.value[i]
        if (value > 999) {
          let parts = value.toString().split('.')
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          value = parts.join('.')
        }
      }
      return value
    },

    /**
     * @param { 柱状图样式 }
     */
    itemStyle(color) {
      return  {
          normal: {
            barBorderRadius: [2, 2, 0, 0],
            color,
            label: {
              position: 'top',
              show: true,
              color: 'rgba(255, 255, 255, 0.85)'
            }
          },
        }
    },

    /**
     * @param { E-charts }
     */
    async DrawECharts() {
      await this.chart_A();
      await this.chart_B();
      await this.chart_C();
      await this.chart_D();
      await this.chart_E();
      await this.chart_F();
      await this.chart_G();
    },

    /**
     * @param { 报名人数分布图 }
     */
    chart_A() {
      let that = this
      let myChart = this.$echarts.init(document.getElementById("chart_A"))
      var option

      let xData = []
      let yData = []
      this.data_A.map(e=>{
        xData.push(e.dataKey.slice(5).replace('-', '/'))
        yData.push(e.dataValue)
      })

      option = {
          grid: {
            x: 48,
            x2: 52,
            y2: 36,
          },
          xAxis: {
            type: 'category',
            data: xData,
          },
          yAxis: {
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                color: '#212E71',
                width: 1,
                type: 'solid',
              }
            }
          },
          series: [
            {
              label: {
                normal: {
                  formatter: (p) => { return that.setNumber (p, 1) }
                }
              },
              data: yData,
              type: 'line',
              smooth: true,
              // 数值显示位置 & 颜色
              itemStyle: {
                normal: {
                  label: {
                    position: 'top',
                    show: true,
                    color: 'rgba(255, 255, 255, 0.85)',
                  }
                }
              },
              // 曲线色
              lineStyle: {
                color: '#00D86C',
              },
              // 阴影渐变
              areaStyle: {
                normal: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: 'rgba(0,216,108,0.35)'
                      },
                      {
                        offset: 1,
                        color: 'rgba(0,216,108,0)'
                      }
                    ],
                    global: false
                  }
                }
              }
            }
          ]
      }
      option && myChart.setOption(option)

      clearInterval(this.Interval_A)
      this.Interval_A = setInterval(() => {
        clearTimeout(timer)
        let timer = setTimeout(function(){
          document.getElementById('chart_A').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_A"))

          let xData = []
          let yData = []
          that.data_A.map(e=>{
            xData.push(e.dataKey.slice(5).replace('-', '/'))
            yData.push(e.dataValue)
          })

          option.xAxis.data = xData
          option.series[0].data = yData
          option && myChart.setOption(option)
        }, 1000)

      }, 60000)

    },

    /**
     * @param { 审核数据统计 }
     */
    chart_B() {
      let myChart = this.$echarts.init(document.getElementById("chart_B"))
      var option
      let that = this

      option = {
        grid: {
          x: 48,
          x2: 52,
          y2: 36,
        },
        dataset: {
          source: this.data_G
        },
        xAxis: { type: 'category' },
        yAxis: {
          splitLine: {
            show: true,
            lineStyle: {
              color: '#212E71',
              width: 1,
              type: 'solid',
            }
          }
        },
        series: [
          {
            label: {
              normal: {
                formatter: (p) => { return that.setNumber (p, 1) }
              }
            },
            type: 'bar', 
            barWidth: '12.5%',
            barMinHeight: 2,
            itemStyle: that.itemStyle('#266EFF'),
          }, 
          { 
            label: {
              normal: {
                formatter: (p) => { return that.setNumber (p, 2) }
              }
            },
            type: 'bar',
            barWidth: '12.5%',
            barMinHeight: 2,
            itemStyle: that.itemStyle('#05C985'),
          }, 
          { 
            label: {
              normal: {
                formatter: (p) => { return that.setNumber (p, 3) }
              }
            },
            type: 'bar',
            barWidth: '12.5%',
            barMinHeight: 2,
            itemStyle: that.itemStyle('#EE423D'),
          }
        ],
      }
      option && myChart.setOption(option)

      clearInterval(this.Interval_B)
      this.Interval_B = setInterval(() => {

        clearTimeout(timer)
        let timer = setTimeout(() => {

          document.getElementById('chart_B').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_B"))

          option.dataset.source = that.data_G
          myChart.setOption(option, true)

        }, 4000)
      }, 60000)

    },

    /**
     * @param { 缴费金额分布图 }
     */
    chart_C() {
      let myChart = this.$echarts.init(document.getElementById("chart_C"))
      var option
      let that = this

      let xData = []
      let yData = []
      this.data_B.map(e=>{
        xData.push(e.dataKey.slice(5).replace('-', '/'))
        yData.push(e.dataValue)
      })

      option = {
        grid: {
          x: 48,
          x2: 52,
          // y: 108,
          y2: 36,
        },
        tooltip: {
          show: false,
        },
        xAxis: {
          type: 'category',
          data: xData
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: '#212E71',
              width: 1,
              type: 'solid',
            }
          }
        },
        series: [
          {
            label: {
              normal: {
                formatter: function(p) {
                  let value = ''
                  if (p.value >= 0) {
                    value = p.value
                    if (value > 999) {
                      let parts = value.toString().split('.')
                      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      value = parts.join('.')
                    }
                  }
                  return value
                }
              }
            },
            data: yData,
            type: 'bar',
            barWidth: "13.4%",
            barMinHeight: 2,
            itemStyle: that.itemStyle('#05C985'),
          }
        ]
      }
      option && myChart.setOption(option)

      // 刷新
      clearInterval(this.Interval_C)
      this.Interval_C = setInterval(() => {

        clearTimeout(timer)
        let timer = setTimeout(() => {
          document.getElementById('chart_C').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_C"))

          let xData = []
          let yData = []
          that.data_B.map(e=>{
            xData.push(e.dataKey.slice(5).replace('-', '/'))
            yData.push(e.dataValue)
          })
          option.xAxis.data = xData
          option.series[0].data = yData
          myChart.setOption(option)          
        }, 7000)
      }, 60000)

    },

    /**
     * @param { 报名数据统计 A }
     */
    chart_D() {
      let myChart = this.$echarts.init(document.getElementById("chart_D"))
      var option
      let that = this

      this.webSign = this.data_C[0].dataValue ? this.data_C[0].dataValue : 0
      this.phoneSign = this.data_C[1].dataValue ? this.data_C[1].dataValue : 0

      this.webSignNum.end = this.data_C[0].dataValue
      this.phoneSignNum.end = this.data_C[1].dataValue

      option = {
        legend: {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['60%', '100%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            label: {
              show: true,
              position: 'center',
              formatter: `{total|报名终端统计}`,
              rich: {
                total: {
                  fontSize: that.isBigScreen ? 14 : 10,
                  lineHeight: 16,
                }
              },
              color: "#FFF",
              fontWeight: 500,
              fontFamily: 'PingFangSC-Regular, PingFang SC',
            },
            itemStyle: {
              normal: {
                color: function(colors) {
                  let list = ['#023AFF', '#FFA63E'];
                  return list[colors.dataIndex]
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: this.phoneSign },
              { value: this.webSign },
            ],
          }
        ]
      };

      option && myChart.setOption(option);

      clearInterval(this.Interval_D)
      this.Interval_D = setInterval(() => {

        clearTimeout(timer)

        let timer = setTimeout(() => {
          document.getElementById('chart_D').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_D"))

          that.webSign = that.data_C[0].dataValue
          that.phoneSign = that.data_C[1].dataValue

          that.webSignNum.start = that.webSignNum.end
          that.webSignNum.end = that.data_C[0].dataValue

          that.phoneSignNum.start = that.phoneSignNum.end
          that.phoneSignNum.end = that.data_C[1].dataValue

          option.series[0].data = [
            { value: that.phoneSign },
            { value: that.webSign },
          ]

          option && myChart.setOption(option)  

        }, 1000)

      }, 60000)

    },

    /**
     * @param { 报名数据统计 B }
     */
    chart_E() {
      let myChart = this.$echarts.init(document.getElementById("chart_E"))
      var option
      let that = this

      let data = [];

      function shuffle(array) {
        var m = array.length,t, i;
        while (m) {
            i = Math.floor(Math.random() * m--);
            t = array[m];
            array[m] = array[i];
            array[i] = t;
        }
        return array;
      }

      let new_data_D = [];
      if (this.data_D.length > 2) {
        new_data_D = shuffle(this.data_D);
        new_data_D = new_data_D.slice(0, 2);
      } else {
        new_data_D = [...this.data_D];
      }

      new_data_D.map(e=>{
        let item = { value: e.dataValue }
        data.push(item)
      })

      if (data.length == 0) {
        data.push({value: 0})
      } else if (data.length == 1) {
        this.chart_E_info.one.end = new_data_D[0].dataValue
        this.chart_E_info.one.name = new_data_D[0].dataKey
      } else {
        this.chart_E_info.one.end = new_data_D[0].dataValue
        this.chart_E_info.one.name = new_data_D[0].dataKey
        this.chart_E_info.two.end = new_data_D[1].dataValue
        this.chart_E_info.two.name = new_data_D[1].dataKey
      }

      option = {
        legend: {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['60%', '100%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            label: {
              show: true,
              position: 'center',
              formatter: `{total|${this.planInfo.optionalSession == 0 ? '教学点报名人数' : '考点报名人数'}}`,
              rich: {
                total: {
                  fontSize: that.isBigScreen ? 14 : 10,
                  lineHeight: 16,
                }
              },
              color: "#FFF",
              lineHeight: 16,
              fontSize: 14,
              fontWeight: 500,
              fontFamily: 'PingFangSC-Regular, PingFang SC'
            },
            itemStyle: {
              normal: {
                color: function(colors) {
                  let list = that.colorList;
                  return list[colors.dataIndex]
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: data
          }
        ]
      }

      option && myChart.setOption(option);
      clearInterval(this.Interval_E)
      this.Interval_E = setInterval(() => {
        clearTimeout(timer)
        let timer = setTimeout(() => {
          document.getElementById('chart_E').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_E"))

          let data = []
          let new_data_D = []
          if (that.data_D.length > 2) {
            new_data_D = shuffle(that.data_D)
            new_data_D = new_data_D.slice(0, 2)
          } else {
            new_data_D = [...that.data_D]
          }

          new_data_D.map(e=>{
            let item = { value: e.dataValue }
            data.push(item)
          })

          if (data.length == 0) {
            data.push({value: 0})
          } else if (data.length == 1) {
            that.chart_E_info.one.end = new_data_D[0].dataValue
            that.chart_E_info.one.name = new_data_D[0].dataKey
          } else {
            that.chart_E_info.one.end = new_data_D[0].dataValue
            that.chart_E_info.one.name = new_data_D[0].dataKey
            that.chart_E_info.two.end = new_data_D[1].dataValue
            that.chart_E_info.two.name = new_data_D[1].dataKey
          }

          option.series[0].data = data
          myChart.setOption(option)          
        }, 1000)

      }, 60000)

    },

    /**
     * @param { 缴费数据统计 A }
     */
    chart_F() {
      let myChart = this.$echarts.init(document.getElementById("chart_F"))
      var option
      let that = this

      let data = []
      function shuffle(array) {
        var m = array.length,t, i;
        while (m) {
            i = Math.floor(Math.random() * m--);
            t = array[m];
            array[m] = array[i];
            array[i] = t;
        }
        return array;
      }

      let new_data_F = [];
      if (this.data_E.length > 2) {
        new_data_F = shuffle(this.data_E);
        new_data_F = new_data_F.slice(0, 2);
      } else {
        new_data_F = [...this.data_E];
      }

      new_data_F.map(e=>{
        let item = { value: e.dataValue }
        data.push(item)
      })

      if (data.length == 0) {
        data.push({value: 0})
      } else if (data.length == 1) {
        this.chart_F_info.one.end = new_data_F[0].dataValue / 100
        this.chart_F_info.one.name = new_data_F[0].dataKey
      } else {
        this.chart_F_info.one.end = new_data_F[0].dataValue / 100
        this.chart_F_info.one.name = new_data_F[0].dataKey
        this.chart_F_info.two.end = new_data_F[1].dataValue / 100
        this.chart_F_info.two.name = new_data_F[1].dataKey
      }

      option = {
        legend: {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['60%', '100%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            label: {
              show: true,
              position: 'center',
              formatter: `{total|科目缴费统计}`,
              rich: {
                total: {
                  fontSize: that.isBigScreen ? 14 : 10,
                  lineHeight: 16,
                }
              },
              color: "#FFF",
              lineHeight: 16,
              fontSize: 14,
              fontWeight: 500,
              fontFamily: 'PingFangSC-Regular, PingFang SC'
            },
            itemStyle: {
              normal: {
                color: function(colors) {
                  let list = ['#023AFF', '#00D86C', '#FFA63E', '#7300E6', '#EE423D', '#266EFF'];
                  return list[colors.dataIndex]
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: data,

          }
        ]
      };

      option && myChart.setOption(option);

      clearInterval(this.Interval_F)
      this.Interval_F = setInterval(() => {

        clearTimeout(timer)
        let timer = setTimeout(() => {
          document.getElementById('chart_F').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_F"))

          let data = []
          let new_data_F = []
          if (that.data_E.length > 2) {
            new_data_F = shuffle(that.data_E)
            new_data_F = new_data_F.slice(0, 2)
          } else {
            new_data_F = [...that.data_E]
          }

          new_data_F.map(e=>{
            let item = { value: e.dataValue }
            data.push(item)
          })

          if (data.length == 0) {
            data.push({value: 0})
          } else if (data.length == 1) {
            that.chart_F_info.one.end = new_data_F[0].dataValue / 100
            that.chart_F_info.one.name = new_data_F[0].dataKey
          } else {
            that.chart_F_info.one.end = new_data_F[0].dataValue / 100
            that.chart_F_info.one.name = new_data_F[0].dataKey
            that.chart_F_info.two.end = new_data_F[1].dataValue / 100
            that.chart_F_info.two.name = new_data_F[1].dataKey
          }

          option.series[0].data = data

          if (data.length == 0) {
            data.push({value: 0})
          }

          myChart.setOption(option)          
        }, 7000)
      }, 60000)

    },

    /**
     * @param { 缴费数据统计 B }
     */
    chart_G() {
      let myChart = this.$echarts.init(document.getElementById("chart_G"))
      var option
      let that = this

      let data = [];
      this.data_F.map(e=>{
        let item = { value: e.dataValue }
        data.push(item);
      })

      this.chart_G_info.one.end = this.data_F[0].dataValue
      this.chart_G_info.two.end = this.data_F[1].dataValue

      option = {
        legend: {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['60%', '100%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            label: {
              show: true,
              position: 'center',
              formatter: `{total|缴费人数统计}`,
              rich: {
                total: {
                  fontSize: that.isBigScreen ? 14 : 10,
                  lineHeight: 16,
                }
              },
              color: "#FFF",
              lineHeight: 16,
              fontSize: 14,
              fontWeight: 500,
              fontFamily: 'PingFangSC-Regular, PingFang SC'
            },
            // 环颜色
            itemStyle: {
              normal: {
                color: function(colors) {
                  let list = ['#00D86C', '#FFA63E'];
                  return list[colors.dataIndex]
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: data,

          }
        ]
      };

      option && myChart.setOption(option);

      clearInterval(this.Interval_G)
      this.Interval_G = setInterval(() => {

        clearTimeout(timer)

        let timer = setTimeout(() => {
          document.getElementById('chart_G').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_G"))

          let data = []
          that.data_F.map(e=>{
            let item = { value: e.dataValue }
            data.push(item)
          })

          option.series[0].data = data
          myChart.setOption(option)

          that.chart_G_info.one.start = that.chart_G_info.one.end
          that.chart_G_info.two.start = that.chart_G_info.two.end
          that.chart_G_info.one.end = that.data_F[0].dataValue
          that.chart_G_info.two.end = that.data_F[1].dataValue       
        }, 7000);
      }, 60000);

    },

    /**
     * @param { 数据总览数据 }
     */
    async initData() {
      // 随机 Math.round(Math.random() * 10)

      // 重置 报名考点(教学点)数
      this.placeCount.end = 0
      // 重置 报名课程
      this.courseCount.end = 0
      // 重置 报名总人数
      this.signCount.end = 0
      // 重置 审核通过总人数
      this.auditCount.end = 0
      // 重置 缴费人次
      this.payCount.end = 0
      // 重置 缴费金额
      this.payMoney.end = 0


      // 批次 ID
      this.planId = this.$route.query.planId;
      // 批次信息
      let res = await getBannerApi({planId: this.planId})
      this.planInfo = { ...res.data }

      if (this.planInfo.endSignFlag == 0) {
        let signStep = ( (this.planInfo.allSignDay - this.planInfo.leftSignDay) / this.planInfo.allSignDay ).toFixed(2) * 10
        signStep = Math.round(signStep)
        let signColor = signStep < 5 ? '#00D86C' : signStep > 4 && signStep < 8 ? '#FFA63E' : '#EE423D'
        this.signStep = signStep
        this.signColor = signColor
      }
      
      if (this.planInfo.needAudit != 0) {
        let auditStep = ( (this.planInfo.allAuditDay - this.planInfo.leftAuditDay) / this.planInfo.allAuditDay ).toFixed(2) * 10
        auditStep = Math.round(auditStep)
        let auditColor = auditStep < 5 ? '#00D86C' : auditStep > 4 && auditStep < 8 ? '#FFA63E' : '#EE423D'
        this.auditStep = auditStep
        this.auditColor = auditColor
      }

      if (this.planInfo.needPay != 0) {
        let payStep = ( (this.planInfo.allPayDay - this.planInfo.leftPayDay) / this.planInfo.allPayDay ).toFixed(2) * 10
        payStep = Math.round(payStep)
        let payColor = payStep < 5 ? '#00D86C' : payStep > 4 && payStep < 8 ? '#FFA63E' : '#EE423D'
        this.payStep = payStep
        this.payColor = payColor
      }

      // 报名考点数
      this.placeCount.start = this.placeCount.end
      this.placeCount.end = this.planInfo.placeCount

      // 报名课程
      this.courseCount.start = this.courseCount.end
      this.courseCount.end = this.planInfo.courseCount

      // 报名总人数
      this.signCount.start = this.signCount.end
      this.signCount.end = this.planInfo.signCount

      // 审核通过总人数
      if (this.planInfo.needAudit != 0) {
        this.auditCount.start = this.auditCount.end
        this.auditCount.end = this.planInfo.auditCount
      }

      // 缴费人次 + 缴费金额
      if (this.planInfo.needPay != 0) {
        this.payCount.start = this.payCount.end
        this.payCount.end = this.planInfo.payCount

        this.planInfo.payMoney = this.planInfo.payMoney / 100
        this.payMoney.start = this.payMoney.end
        this.payMoney.end = this.planInfo.payMoney
      }
    },

    /***************************************
     * @param { E-charts 图形数据 }
     ***************************************/
    async initECharts(val) {
      this.planId = val

      let { data } = await getDataListApi({ planId: this.planId })
      data = !data ? [] : data

      this.data_A = []
      this.data_B = []
      this.data_C = []
      this.data_D = []
      this.data_E = []
      this.data_F = []

      data.map(e=>{
        if (e.dataType == 1) {
          this.data_A.push(e)
        } else if (e.dataType == 2) {
          e.dataValue = e.dataValue / 100
          this.data_B.push(e)
        } else if (e.dataType == 3) {
          this.data_C.push(e)
        } else if (e.dataType == 4) {
          this.data_D.push(e)
        } else if (e.dataType == 5) {
          this.data_E.push(e)
        } else if (e.dataType == 6) {
          this.data_F.push(e)
        }
      })

      let res = await getAuditInfoApi({ planId: this.planId })
      let auditList = res.data
      if (auditList.auditFlag == 1) {
        this.data_G[0] = ['初审', auditList.auditWill, auditList.auditPass, auditList.auditNoPass]
        if (auditList.auditFinalFlag == 1) {
          this.data_G[1] = ['终审', auditList.auditFinalWill, auditList.auditFinalPass, auditList.auditFinalNoPass]
        } else {
          this.data_G[0] = ['审核', auditList.auditWill, auditList.auditPass, auditList.auditNoPass]
        }
      }

      if (auditList.auditFinalFlag == 1 && auditList.auditFlag == 1) {
        this.data_G[1] = ['终审', auditList.auditFinalWill, auditList.auditFinalPass, auditList.auditFinalNoPass]
      } else {
        this.data_G[0] = ['审核', auditList.auditFinalWill, auditList.auditFinalPass, auditList.auditFinalNoPass]
      }

      this.data_H = auditList.auditList

      let list = await getSignAndPayListApi({ planId: this.planId })
      list = list.data
      let data_I = []
      let data_J = []
      list.map(e=>{
        if (e.operationType == 1) {
          data_I.push(e)
        } else if (e.operationType == 3) {
          data_J.push(e)
        }
      })

      if (!this.chang_A) {
        this.data_I = data_I
        this.data_J = data_J
      }

      if (this.start_ECharts) {
        this.start_ECharts = !this.start_ECharts
        let that = this
        let timer_Draw = setTimeout( function () {
          that.DrawECharts()
          clearTimeout(timer_Draw)
        }, 1000)
      }

    },

  },

  created() {
    let that = this
    // Banner Top 数据
    this.initData()
    clearInterval(this.timer_data)
    this.timer_data = setInterval(() => {
      that.initData()
    }, 30000)
  },
  
  mounted() {
    let that = this

    // 获取当前时间
    this.currentDate()

    // Logo
    this.getCustomSet()

    // 更新 E-charts 数据
    clearInterval(this.timer_Int)
    this.timer_Int = setInterval(() => {
      that.initECharts(that.planId)
    }, 5000)

    // 环形图 <==> 滚动列表
    clearInterval(this.timer_Change)
    this.timer_Change = setInterval(() => {
      that.chang_A = !that.chang_A
    }, 30000)
    
    // 检测页面宽度
    let w = document.documentElement.clientWidth || document.body.clientWidth
    this.isBigScreen = w > 1600 ? true: false

  },

  beforeDestroy() {
    clearInterval(this.currentTime)
    clearInterval(this.timer_data)
    clearInterval(this.timer_Change)
    clearInterval(this.timer_Int)
    clearInterval(this.Interval_A)
    clearInterval(this.Interval_B)
    clearInterval(this.Interval_C)
    clearInterval(this.Interval_D)
    clearInterval(this.Interval_E)
    clearInterval(this.Interval_F)
    clearInterval(this.Interval_G)
  }

};
</script>

<style lang="less" scoped>
[v-cloak] {
  display: none;
}
.Data_V_Border {
  width: 100vw;
  height: 100%;
  background: #00134D;
}
// Rem ==> 屏幕宽度 1/10;
#Data_V {
  width: 100vw;
  height: calc(108/198 * 10rem);
  padding: 0 0.12rem 0.12rem;
  box-sizing: border-box;
  background: #00134D;
  display: flex;
  flex-direction: column;

  .Title {
    height: calc((90/1080) * 100%);
  }

  .Top {
    height: calc((200/1080) * 100%);
  }

  .Middle {
    height: calc((40/108) * 100%);
  }

  .Bottom {
    height: calc((38/108) * 100%);
  }

  .Title,.Top,.Middle,.Bottom {
    width: 100%;
    margin-bottom: 1%;
  }

  .Title,.Bottom {
    margin: 0;
  }

  .Top {
    background: #0F1D66;
    border-radius: .03rem;
    padding: .12rem .1rem;
    box-sizing: border-box;
  }

  // Logo + Title + Date
  .Title {
    font-size: .18rem;
    font-weight: 600;
    line-height: .45rem;
    text-align: center;
    color: #FFF;

    display: flex;
    justify-content: space-between;
    align-items: center;

    font-family: 'PingFangSC-Semibold, PingFang SC';

    &>img {
      float: left;
      height: .18rem;
    }

    &>.Date {
      &>span:first-child {
        font-size: 0.08rem;
        font-weight: 400;
        color: rgba(255,255,255,0.85);
        margin-right: .06rem;
        font-family: 'PingFangSC-Regular, PingFang SC';
      }

      &>span:last-child {
        font-size: .1rem;
        font-weight: 600;
        color: #FFF;
        font-family: 'PingFangSC-Semibold, PingFang SC';
      }

    }
  }

  // Top
  .Top {
    .Top_title {
      display: flex;
      align-items: center;
      margin-bottom: .18rem;
      font-family: 'PingFangSC-Medium, PingFang SC';
      box-sizing: border-box;

      .title_A {
        width: .03rem;
        height: .1rem;
        margin-right: 0.03rem;

        background: #266EFF;
        border-radius: .03rem;
        border-right: 0;
      }

      .title_B {
        font-size: .11rem;
        font-weight: 500;
        line-height: .12rem;
        color: #FFF;
      }
    }

    .Top_main {
      width: 100%;
      height: .34rem;
      display: flex;
      justify-content: space-between;

      .item {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
      }

      // 进度条类型
      .item_A,.item_B,.item_C {
        display: flex;
        flex-wrap: wrap;
        width: 1.02rem;
        padding-left: .06rem;
        padding-right: .26rem;
        box-sizing: border-box;

        .item_dule {
          width: 100%;
          height: .22rem;

          display: flex;
          justify-content: left;
          align-items: center;

          &>div:first-child {
            font-size: .08rem;
            font-weight: 400;
            color: #A3A7BF;
            font-family: 'PingFangSC-Medium, PingFang SC';
          }

          &>div:last-child {
            margin-left: .12rem;
            font-size: .18rem;
            font-weight: 500;
            color: #EE423D;
            font-family: 'DIN-Medium, DIN';
          }

        }

        .dule {
          width: 100%;
          height: .04rem;
          display: flex;

          .dule_item {
            width: .065rem;
            height: .04rem;
            margin-right: 1px;
            background: #27357E;
            opacity: 0.8;
          }

          .dule_item:first-child {
            border-radius: 50% 0px 0px 50%;
          }

          .dule_item:last-child {
            margin: 0;
            border-radius:  0px 50% 50% 0px;
          }

        }


      }

      .item_B .item_dule div:last-child {
        color: #FFA63E;
      }

      .item_C .item_dule div:last-child {
        color: #00D86C;
      }

      .item_D {
        border-left: 1px solid rgba(255,255,255,0.12);
        .item_dule {
          text-align: center;
          &>span {
            color: #FFF;
          }
          &>span:first-child {
            font-size: .18rem;
            font-family: 'DIN-Medium, DIN';
            font-weight: 500;
            line-height: .22rem;
            margin-right: .02rem;
          }
          &>span:last-child {
            font-size: .08rem;
            line-height: 22px;
            color: #A3A7BF;
            font-family: 'PingFangSC-Regular, PingFang SC';
          }
        }
        .item_des {
          text-align: center;
          font-size: .08rem;
          font-family: 'PingFangSC-Regular, PingFang SC';
          font-weight: 400;
          color: #A3A7BF;
          line-height: .12rem;
        }

      }



    }

  }

  // Middle
  .Middle {
    display: flex;
    justify-content: space-between;

    .Left {
      width: 3.5rem;
      box-sizing: border-box;

      #chart_A {
        padding-top: .24rem;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
      }
      
    }

    .Center {
      width: 2.5rem;
      min-width: 2.5rem;
      #chart_B {
        width: 100%;
        height: 100%;
        padding-top: .24rem;
        box-sizing: border-box;
      }
      .strate {
        width: 100%; 
        height: 20px; 
        box-sizing: border-box; 
        position: absolute;
        top:.32rem;
        display: flex;
        justify-content: space-around;
        padding: 0 .4rem;
        &>div {

          display: flex;
          align-items: center;

          div {
            width:.06rem; 
            height:.04rem;
            border-radius:2px;
          }

          span {
            color: #A3A7BF;
            margin-left: .03rem;
            font-size: 14px;
            font-family: 'PingFangSC-Regular, PingFang SC';
          }
        }

      } 
    }

    .Right {
      width: 3.5rem;
      #chart_C {
        padding-top: .24rem;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
      }
    }

    .Left,.Center,.Right {
      height: 100%;
      position: relative;
      background: #0F1D66;
      border-radius: .03rem;
      overflow: hidden;

      .title {
        width: 100%;
        padding-top: 24px;
        padding-left: 20px;
        padding-right: 24px;
        box-sizing: border-box;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: space-between;

        font-family: 'PingFangSC-Medium, PingFang SC';

        &>div {

          display: flex;
          align-items: center;

          .title_A {
            width: .03rem;
            height: .1rem;
            margin-right: 0.03rem;

            background: #266EFF;
            border-radius: .03rem;
            border-right: 0;
          }

          .title_B {
            font-size: .11rem;
            font-weight: 500;
            line-height: .12rem;
            color: #FFF;
          }

        }

        .title_C {
          font-size: .08rem;
          color: #A3A7BF;
          font-family: 'PingFangSC-Regular, PingFang SC';
          line-height: .12rem;
          float: right;
        }
      }


    }

  }

  // Bottom
  .Bottom {
    display: flex;
    justify-content: space-between;

    .Left {
      width: 3.5rem;
      box-sizing: border-box;

      .charts {
        height: 1.45rem;
        width: 100%;
        margin-top: .42rem;
        display: flex;
        box-sizing: border-box;
        justify-content: space-around;
        .chart_D {
          width: .9rem;
          height: 100%;
          // margin-left: .32rem;

          .chart_D_Border {
            width: .9rem;
            height: .9rem;

            #chart_D {
              width: 100%;
              height: 100%;
            }

          }

          .info_Mob,.info_Web {
            height: .12rem;
            color: #FFF;
            font-size: .07rem;
            font-family: 'PingFangSC-Regular, PingFang SC';
            display: flex;
            align-items: center;
            margin-top: .11rem;

            .dit {
              display: inline-block;
              width: .04rem;
              height: .04rem;
              margin-right: .04rem;
              border-radius: 50%;
              background: #023AFF;
            }

            .number {
              margin: 0 .04rem;
              font-size: .09rem;
              font-weight: 500;
              font-family: 'Futura-Medium, Futura';
            }

          }

          .info_Web {
            margin-top: .06rem;
            .dit {
              background: #FFA63E;
            }
          }

        }

        .chart_E {
          width: 1.37rem;
          height: 100%;
          // margin-left: .48rem;

          .chart_E_Border {
            width: .9rem;
            height: .9rem;
            margin: 0 auto;

            #chart_E {
              width: 100%;
              height: 100%;
            }

          }

          .info_A,.info_B,.info_C,.info_D {
            width: 100%;
            height: .12rem;
            color: #FFF;
            font-size: .07rem;
            font-family: 'PingFangSC-Regular, PingFang SC';
            display: flex;
            align-items: center;

            .dit {
              display: inline-block;
              width: .04rem;
              height: .04rem;
              margin-right: .04rem;
              border-radius: 50%;
            }

            .number {
              margin: 0 .04rem;
              font-size: .09rem;
              font-weight: 500;
              font-family: 'Futura-Medium, Futura';
            }

          }

          .info_A {
            margin-top: .11rem;
            .dit {
              background: #023AFF;
            }
          }

          .info_B {
            margin-top: .06rem;
            .dit {
              background: #FFA63E;
            }
          }

          .info_C {
            .dit {
              background: #00D86C;
            }
          }

          .info_D {
            .dit {
              background: #7300E6;
            }
          }

        }

      }

      .list {
        .Scroll {
          width: 100%;
          height: 1.55rem;
          position: absolute;
          bottom: 0;
          padding: .11rem .15rem .075rem;
          box-sizing: border-box;
          overflow: hidden;

          .VueScoll {
            height: 100%; 
            overflow: hidden;
            ul li {
              height: .24rem;
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-size: .08rem;
              font-family: 'PingFangSC-Regular, PingFang SC';
              .A {
                color: #FFF;
                opacity: .85;
                min-width: .3rem;
                width: auto;
              }
              .B {
                color: #FFF;
                opacity: .85;
                min-width: .9rem;
                width: auto;
              }
              .C {
                color: #FFF;
                opacity: .85;
                min-width: .8rem;
                width: auto;
                text-align: right;
              }
            }
          }

        }        
      }

    }

    .Center {
      width: 2.5rem;
      min-width: 2.5rem;
      .Scroll {
        width: 100%;
        height: 1.55rem;
        position: absolute;
        bottom: 0;
        padding: .11rem .15rem .075rem;
        box-sizing: border-box;
        overflow: hidden;

        .VueScoll {
          height: 100%; 
          overflow: hidden;
          ul li {
            height: .24rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: .08rem;
            font-family: 'PingFangSC-Regular, PingFang SC';
            .A {
              color: #FFF;
              opacity: .85;
              min-width: .3rem;
              width: auto;
            }
            .B {
              color: #FFF;
              opacity: .85;
              min-width: .9rem;
              width: auto;
            }
            .C {
              color: #00D86C;
              width: .4rem;
              text-align: right;
            }
          }
        }

      }

    }

    .Right {
      width: 3.5rem;

      .charts {
        height: 1.45rem;
        width: 100%;
        margin-top: .42rem;
        display: flex;
        justify-content: space-around;

        .chart_F,.chart_G {
          width: .9rem;
          height: 100%;

          .chart_F_Border,.chart_G_Border {
            width: .9rem;
            height: .9rem;

            #chart_F,#chart_G {
              width: 100%;
              height: 100%;
            }

          }

          .info_Mob,.info_Web {
            height: .12rem;
            color: #FFF;
            font-size: .07rem;
            font-family: 'PingFangSC-Regular, PingFang SC';
            display: flex;
            align-items: center;
            margin-top: .11rem;

            .dit {
              display: inline-block;
              width: .04rem;
              height: .04rem;
              margin-right: .04rem;
              border-radius: 50%;
              background: #023AFF;
            }

            .number {
              margin: 0 .04rem;
              font-size: .09rem;
              font-weight: 500;
              font-family: 'Futura-Medium, Futura';
            }

          }

          .info_Web {
            margin-top: .06rem;
            .dit {
              background: #FFA63E;
            }
          }

        }
      }

      .list {
        .Scroll {
          width: 100%;
          height: 1.55rem;
          position: absolute;
          bottom: 0;
          padding: .11rem .15rem .075rem;
          box-sizing: border-box;
          overflow: hidden;

          .VueScoll {
            height: 100%; 
            overflow: hidden;
            ul li {
              height: .24rem;
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-size: .08rem;
              font-family: 'PingFangSC-Regular, PingFang SC';
              .A {
                color: #FFF;
                opacity: .85;
                min-width: .3rem;
                width: auto;
              }
              .B {
                color: #FFF;
                opacity: .85;
                min-width: .9rem;
                width: auto;
              }
              .C {
                color: #FFF;
                opacity: .85;
                width: .8rem;
                text-align: right;
              }
            }
          }

        }        
      }

    }

    .Left,.Center,.Right {
      height: 100%;
      position: relative;
      background: #0F1D66;
      border-radius: .03rem;
      overflow: hidden;

      .title {
        width: 100%;

        padding-top: 24px;
        padding-left: 20px;
        padding-right: 24px;
        box-sizing: border-box;

        position: absolute;

        display: flex;
        align-items: center;
        justify-content: space-between;

        font-family: 'PingFangSC-Medium, PingFang SC';

        &>div {

          display: flex;
          align-items: center;

          .title_A {
            width: .03rem;
            height: .1rem;
            margin-right: 0.03rem;

            background: #266EFF;
            border-radius: .03rem;
            border-right: 0;
          }

          .title_B {
            font-size: .11rem;
            font-weight: 500;
            line-height: .12rem;
            color: #FFF;
          }

        }

        .title_C {
          font-size: .08rem;
          color: #A3A7BF;
          font-family: 'PingFangSC-Regular, PingFang SC';
          line-height: .12rem;
          float: right;
        }
      }

    }
  }

}
</style>
